module.exports = __webpack_public_path__ + "img/edc-shopeepay.e6888f0a.png";